const getPreference = (
  teamReference: wowaudit.TeamReference,
  preferenceMap: Map<string, { order_in_menu?: number }>,
) => {
  const ownerKey = `owner_${teamReference.ownerReference.id}`
  const teamKey = `team_${teamReference.id}`
  const ownerPreference = preferenceMap.get(ownerKey)
  const teamPreference = preferenceMap.get(teamKey)

  return {
    hasPreference: Boolean(ownerPreference || teamPreference),
    order:
      teamPreference?.order_in_menu ?? ownerPreference?.order_in_menu ?? 99,
  }
}

export const useVisibleTeamsForUser = (user: wowaudit.User | undefined) => {
  if (!user) return []

  const visibleTeamPreferences = user.teamPreferences.filter(
    (teamPreference) => teamPreference.visibility === 'visible',
  )

  const preferenceMap = new Map(
    visibleTeamPreferences.map((preference) => {
      const key = preference.team_id
        ? `team_${preference.team_id}`
        : `owner_${preference.owner_id}`
      return [key, preference]
    }),
  )

  return user.teamReferences
    .map((teamReference) => ({
      teamReference,
      preference: getPreference(teamReference, preferenceMap),
    }))
    .filter(({ preference }) => preference.hasPreference)
    .sort((a, b) => a.preference.order - b.preference.order)
    .map(({ teamReference }) => teamReference)
}
